import React from "react";
import { useCall } from "../../Hooks/EntityHooks";

export const ConnectCallEntity = Component => {
  return ({ call, ...rest }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const c = useCall(call);
    return <Component call={c} {...rest} />;
  };
};